import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type {
  UpdateJobNotificationsReadStatusRequestPayload,
  UpdateJobNotificationsReadStatusResponse,
} from '@vy/api-definition';

type UpdateNotificationsInput = UpdateJobNotificationsReadStatusRequestPayload;

export function useUpdateNotificationsReadStatus(
  options?: UseMutationOptions<UpdateJobNotificationsReadStatusResponse, unknown, UpdateNotificationsInput>,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateNotificationsInput) => {
      const api = getPrivateApi();
      const response = await api.updateJobNotificationsReadStatus({
        updateJobNotificationsReadStatusRequest: payload,
      });

      return response;
    },
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.jobs() });

      if (options?.onSuccess) {
        await options.onSuccess(data, variables, context);
      }
    },
    onError: async (error, variables, context) => {
      console.error('Failed to update notification read status:', error);

      if (options?.onError) {
        await options.onError(error, variables, context);
      }
    },
  });
}
